/**
 * Дата-время из ответа API в виде, пригодном для ячейки таблицы: локальное
 * представление браузера, а для отсутствующего значения — прочерк. Один и тот
 * же вид во всех списках, чтобы столбцы дат читались одинаково.
 */
export function formatDate(value: string | null): string {
  const shown = value === null ? "—" : new Date(value).toLocaleString();
  return shown;
}
